
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/van",
      function () {
        return require("private-next-pages/rims/van.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/van"])
      });
    }
  